// ReportsPage.js

import React from "react";
import { 
  ReportsPageContainer,
  ReportsSection,
  ReportCard,
  ReportImage,
  ReportText,
  ReportDate,
  ReportTitle,
  ReportDescription,
  ReadMoreLink,  // Import from StyledReports.js
} from '../Styles/StyledReports.js';
import r1 from '../Images/r1.webp'
import r2 from '../Images/r2.webp'
import r3 from '../Images/r3.webp'
import r4 from '../Images/r4.jpeg'
import r5 from '../Images/r5.jpeg'
import r6 from '../Images/r6.jpeg'
import r7 from '../Images/r7.jpeg'
import r8 from '../Images/r8.jpeg'
import r9 from '../Images/r9.jpeg'

const reports = [
  {
    id: 1,
    date: "10/8/24",
    title: "Q3 2024 MICHAEL REPORT",
    image: r1,
    description: "This is the description for the Q3 2024 report."
  },
  {
    id: 2,
    date: "7/7/24",
    title: "Mid-Year 2024 MICHAEL REPORT",
    image: r2,
    description: "This is the description for the Mid-Year 2024 report."
  },
  {
    id: 3,
    date: "4/5/24",
    title: "Q1 2024 MICHAEL REPORT",
    image: r3,
    description: "This is the description for the Q1 2024 report."
  },
  {
    id: 4,
    date: "12/10/23",
    title: "Year-End 2023 MICHAEL REPORT",
    image: r4,
    description: "This is the description for the Year-End 2023 report."
  },
  {
    id: 5,
    date: "9/8/23",
    title: "Q3 2023 MICHAEL REPORT",
    image: r5,
    description: "This is the description for the Q3 2023 report."
  },
  {
    id: 6,
    date: "6/6/23",
    title: "Mid-Year 2023 MICHAEL REPORT",
    image: r6,
    description: "This is the description for the Mid-Year 2023 report."
  },
  {
    id: 7,
    date: "3/3/23",
    title: "Q1 2023 MICHAEL REPORT",
    image: r7,
    description: "This is the description for the Q1 2023 report."
  },
  {
    id: 8,
    date: "12/9/22",
    title: "Year-End 2022 MICHAEL REPORT",
    image: r8,
    description: "This is the description for the Year-End 2022 report."
  },
  {
    id: 9,
    date: "9/7/22",
    title: "Q3 2022 MICHAEL REPORT",
    image: r9,
    description: "This is the description for the Q3 2022 report."
  },
];


const ReportsPage = () => {
  return (
    <ReportsPageContainer>
      <ReportsSection>
        {reports.map((report) => (
          <ReportCard key={report.id}>
            <ReportImage src={report.image} alt={report.title} />
            <ReportText>
              <ReportDate>{report.date}</ReportDate>
              <ReportTitle>{report.title}</ReportTitle>
              <ReportDescription>
                <p>{report.description}</p>
              </ReportDescription>
              <ReadMoreLink to={`/report/${report.id}`}>Read More</ReadMoreLink>
            </ReportText>
          </ReportCard>
        ))}
      </ReportsSection>
    </ReportsPageContainer>
  );
};

export default ReportsPage;
